import { pageEnum } from "../Common";

export const getListingUrl = (type) => {
  switch (type) {
    case pageEnum.LongLets:
      return "/long-lets";
    case pageEnum.CommercialLets:
      return "/commercials";
    case pageEnum.ShortLets:
      return "/short-lets";
    case pageEnum.ResidentialSale:
      return "/residential-sales";
    case pageEnum.CommercialSale:
      return "/commercial-sales";
    case pageEnum.Room:
      return "/room";
    default:
      return "#";
  }
};

export const getListingName = (type) => {
  switch (type) {
    case pageEnum.LongLets:
      return "Malta Long Let Properties";
    case pageEnum.CommercialLets:
      return "Commercial Properties in Malta";
    case pageEnum.ShortLets:
      return "Short Let Properties";
    case pageEnum.ResidentialSale:
      return "Property Residential Sale in Malta";
    case pageEnum.CommercialSale:
      return "Property Commercial Sale in Malta";
    case pageEnum.Room:
      return "Rooms in Malta";
    default:
      return "";
  }
};

// Form gönderimlerinde API'nin döndürdüğü hata mesajını çıkarır.
// Backend AutoWrapper ile sarmalanıyor; hata gövdesi sürüme göre
// responseException.exceptionMessage / message / düz string olabiliyor.
export const getApiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  const message =
    data?.responseException?.exceptionMessage ||
    data?.message ||
    (typeof data === "string" ? data : null);

  return message || fallback || "An unexpected error has occurred. Please try again.";
};

export const getQueryParam = (name, url) => {
  if (!url) url = document.location.href;
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results == null ? null : results[1];
};
